<template>
  <v-menu :close-on-content-click="false" transition="scale-transition" origin="right top" v-model="menuOpen"
          offset-y :min-width="$vuetify.breakpoint.mobile?'0':'700px'" max-width="700px" nudge-left="650">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon><v-icon>mdi-calculator</v-icon></v-btn>
    </template>
    <v-card class="text-body-2">
      <v-card-title>
        Alcohol calculator
        <v-spacer/>
        <v-btn icon small @click="menuOpen=false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-container>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-btn-toggle v-model="output" dense tile color="green" @change="changeOutput();resetResult()">
              <v-btn value="LAA" small>LAA</v-btn>
              <v-btn value="Strength" small>Strength</v-btn>
              <v-btn value="Weight" small>Weight</v-btn>
              <v-btn value="Volume" small>Volume</v-btn>
              <v-btn value="Proof" small>Proof</v-btn>
            </v-btn-toggle>
            <v-radio-group v-model="option" v-if="output==='LAA' || output==='Proof'" @change="resetResult">
              <v-radio label="From density/weight" color="green" value="A"/>
              <v-radio label="From density/volume" color="green" value="B"/>
              <v-radio label="From ABV/weight" color="green" value="C"/>
              <v-radio label="From ABV/volume" color="green" value="D"/>
              <v-radio label="From ABW/weight" color="green" value="N" v-if="output==='LAA'"/>
            </v-radio-group>
            <v-radio-group v-model="option" v-else-if="output==='Strength'" @change="resetResult">
              <v-radio label="From density" color="green" value="E"/>
            </v-radio-group>
            <v-radio-group v-model="option" v-else-if="output==='Weight'" @change="resetResult">
              <v-radio label="From density/LAA" color="green" value="F"/>
              <v-radio label="From density/Volume" color="green" value="G"/>
              <v-radio label="From ABV/LAA" color="green" value="H"/>
              <v-radio label="From ABV/Volume" color="green" value="I"/>
            </v-radio-group>
            <v-radio-group v-model="option" v-else-if="output==='Volume'" @change="resetResult">
              <v-radio label="From density/LAA" color="green" value="J"/>
              <v-radio label="From density/Weight" color="green" value="K"/>
              <v-radio label="From ABV/LAA" color="green" value="L"/>
              <v-radio label="From ABV/Weight" color="green" value="M"/>
            </v-radio-group>
          </v-col>

          <v-col cols="12" sm="6">
            <v-form v-model="valid">
            <v-container class="pt-0">
              <v-row dense>
                <v-col cols="6">
                  <decimal-number-input label="Temperature" v-model="temp" v-if="option!=='N'"
                                        prefix="" suffix="°C" :precision="1"
                                        hint="Increments of 0.5" :min="-20" :max="40" :rules="[halfDegree]"/>
                </v-col>
                <v-col cols="6">
                  <decimal-number-input v-if="'ABEFGJK'.includes(option)"
                                        label="Density" v-model="density"
                                        prefix="" suffix="kg/m³" :precision="1"
                                        hint="Increments of 0.2" :min="780" :max="999.8" :rules="[point2]"/>
                  <decimal-number-input v-if="'CDHILM'.includes(option)"
                                        label="ABV" v-model="strength"
                                        prefix="" suffix="% ABV" :precision="2"/>
                  <decimal-number-input v-if="'N'.includes(option)"
                                        label="ABW" v-model="strength"
                                        prefix="" suffix="% ABW" :precision="2"/>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  <decimal-number-input v-if="'ACKMN'.includes(option)"
                                        label="Weight" v-model="weight" prefix="" suffix="kg" :precision="3"/>
                  <decimal-number-input v-if="'BDGI'.includes(option)"
                                        label="Volume" v-model="volume" prefix="" suffix="litres" :precision="3"/>
                  <decimal-number-input v-if="'FHJL'.includes(option)"
                                        label="LAA" v-model="laa" prefix="" suffix="" :precision="3"/>
                </v-col>
                <v-col cols="6">
                  <decimal-number-input v-if="'ACKMN'.includes(option)"
                                        label="Tare" v-model="tare" prefix="" suffix="kg " :precision="3"/>
                </v-col>
              </v-row>
              <v-row dense v-if="output==='Proof'">
                <v-col cols="6">
                  <decimal-number-input label="Target ABV" v-model="targetStrength" prefix="" suffix="% ABV" :precision="2"/>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-btn color="primary" @click="calculate()" :loading="loading">Calculate</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-if="result" :label="output" readonly dense background-color="green lighten-3" hide-details v-model="result"/>
                </v-col>
              </v-row>
            </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'Calculator',
  data() {
    return {
      valid: true,
      menuOpen: false,
      temp: 20,
      density: 900,
      weight: 0,
      tare: 0,
      volume: 0,
      strength: 40,
      targetStrength: 40,
      laa: 0,
      halfDegree: v => v % .5 === 0 || 'Increments of 0.5',
      point2: v => v*10 % 2 === 0 || 'Increments of 0.2',
      output: 'LAA',
      option: "A",
      loading: false,
      result: null
    }
  },
  methods: {
    changeOutput() {
      if (this.output === 'LAA')
        this.option = 'A';
      else if (this.output === 'Strength')
        this.option = 'E';
      else if (this.output === 'Weight')
        this.option = 'F';
      else if (this.output === 'Volume')
        this.option = 'J';
    },
    resetResult() {
      this.result = null;
    },
    async calculate() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }      this.loading = true;
      const lookup = await ('ABEFGJK'.includes(this.option) ? this.lookupByDensity() : this.lookupByStrength(this.option === 'N' ? 100 : this.strength));
      this.loading = false;
      if (!lookup)
        return;
      switch (this.output) {
        case 'LAA':
        case 'Proof':
          let laa;
          if (this.option === 'A' || this.option === 'C')
            laa = (this.weight - this.tare) * lookup.a * lookup.b / 100;
          else if (this.option === 'B' || this.option === 'D')
            laa = this.volume * lookup.c * lookup.b / 100;
          else if (this.option === 'N')
            laa = (this.weight - this.tare) * (this.strength/100) / 0.78924;

          if (this.output === 'Proof')
            await this.calculateProof(laa);
          else
            this.result = this.$number(laa, 3);
          break;
        case 'Strength':
          this.result = this.$number(lookup.b, 2) + '% alc/vol';    // E
          break;
        case 'Weight':
          if (this.option === 'F' || this.option === 'H')
            this.result = this.$number(this.laa / (lookup.a * lookup.b/100), 3) + ' kg';
          else if (this.option === 'G' || this.option === 'I')
            this.result = this.$number(this.volume*lookup.c / lookup.a, 3) + ' kg';
          break;
        case 'Volume':
          if (this.option === 'J' || this.option === 'L')
            this.result = this.$number(this.laa / (lookup.c * lookup.b/100), 3) + ' litres';
          else if (this.option === 'K' || this.option === 'M')
            this.result = this.$number((this.weight - this.tare) * lookup.a / lookup.c, 3) + ' litres';
          break;
      }
    },
    async calculateProof(laa) {
      const results = await this.$apiCall(`query Calculator($temp: Float!, $b: Float!) {
                                              alcoholometricLookupByStrength(temp:$temp, b:$b) {temp,density,a,b,c}
                                            }`,
                                          {temp:this.temp,b:this.targetStrength});
      if (!results.error) {
        const lookup = results.data.alcoholometricLookupByStrength;
        const weight = laa / (lookup.a * lookup.b/100);
        if (this.option === 'A' || this.option === 'C')
          this.result = this.$number(weight + this.tare, 3) + ' kg';
        else
          this.result = this.$number(weight * lookup.a / lookup.c, 3) + ' litres';
      }
    },
    async lookupByDensity() {
      const results = await this.$apiCall(`query Calculator($temp: Float!, $density: Float!) {
                                              alcoholometricLookupByDensity(temp:$temp, density:$density) {temp,density,a,b,c}
                                            }`,
                                          {temp:this.temp,density:this.density});
      if (!results.error)
        return results.data.alcoholometricLookupByDensity;
    },
    async lookupByStrength(strength) {
      const results = await this.$apiCall(`query Calculator($temp: Float!, $b: Float!) {
                                              alcoholometricLookupByStrength(temp:$temp, b:$b) {temp,density,a,b,c}
                                            }`,
                                          {temp:this.temp,b:strength});
      if (!results.error)
        return results.data.alcoholometricLookupByStrength;
    }
  }
}
</script>